import { ComponentRef } from '@angular/core';
import 'reflect-metadata';
import { ViewProvider } from 'src/app/components/table/utils/table-interfaces';
import { TableView } from 'src/app/components/table/utils/table-view.model';
import { Translate } from 'src/app/model/Translate';
import { ComponentName } from 'src/app/util/component-map/component-names';
import { OpenableComponent } from 'src/app/util/directives/open-on-panel.directive';

export interface DrawerModel extends OpenableComponent {
  id?: number;
  title: Translate;
  icon?: string;
  position: DrawerPositionType;
  active?: boolean;
  outputCallbacks?: any;
  componentRef?: ComponentRef<DrawerModelComponent>;
  view?: TableView;
  onTabLoaded?: (tab: DrawerModel) => void;
  onTabClosed?: () => void;
  onTabSelected?: () => void;
}

export interface DrawerModelComponent extends Partial<ViewProvider<any>> {
  /**
   * @returns {string[]} - Messages indicating the need for confirmation, or null if no confirmation is required.
   */
  requestClose(): string[];
}

export enum DrawerPosition {
  SIDE = 'side',
  BOTTOM = 'bottom',
  MAIN = 'main',
  DEFAULT = 'default',
}

export enum COMMON_PANEL_WIDTH {
  DETAILED_VIEW = '500px',
  PAGE = '50%',
}

export type DrawerPositionType = `${DrawerPosition}`;

export type CheckExistingTabsComparatorParam = Pick<DrawerModel, 'inputs' | 'title' | 'component'>;

export type OpenableType = {
  component: ComponentName;
  width?: `${COMMON_PANEL_WIDTH}` | string;
  title?: string;
  icon?: string;
  checkExistingTabs?: boolean;
  checkExistingTabsComparator?: (
    a: CheckExistingTabsComparatorParam,
    b: CheckExistingTabsComparatorParam
  ) => boolean;
};

export type StringOrKeyOf<T> = T extends string ? string : keyof T;

export const checkExistingTabsByIdOfProperty =
  <T = string>(property: StringOrKeyOf<T>) =>
  (a: CheckExistingTabsComparatorParam, b: CheckExistingTabsComparatorParam) => {
    const isComponentTheSame = a.component === b.component;
    const isIdTheSame = a.inputs[property].id === b.inputs[property].id;
    return isComponentTheSame && isIdTheSame;
  };
